module.exports = __webpack_public_path__ + "static/media/house.657ca692.svg";